

import _util from '../../utils/';

const personalCenter = {
    fetchPersonalCenter (params, resolve, reject) {
        _util.request({
            url: '/api/EmpPointPersonal/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchMySalary (params, resolve, reject) {
        _util.request({
            // url: '/api/EmployeePointMySalary/Get',
            url: '/api/HRSalarySalaryAccountDetails/My',
            params: params,
            success: resolve,
            error: reject
        })
    },
  sendSms (payload, resolve, reject) {
    _util.request({
      url: '/api/auth/sendSms',
      method: "post",
      data: payload,
      success: resolve,
      error: reject
    })
  },
  verifySmsCode (payload, resolve, reject) {
    _util.request({
      url: '/api/auth/verifyCode',
      method: "post",
      data: payload,
      success: resolve,
      error: reject
    })
  },

}


export default personalCenter;


// WEBPACK FOOTER //
// ./src/services/Employee/personal-center-service.js